import {IResource} from '@simpli/resource-collection'
import {Request, ResponseSerialize} from '@simpli/serialized-request'
import {SocialType} from '@/model/resource/SocialType'
import {GithubOrganization} from '@/model/resource/GithubOrganization'

export class GithubOrganizationSocialType implements IResource {
  @ResponseSerialize(GithubOrganization)
  githubOrganization: GithubOrganization | null = null

  @ResponseSerialize(SocialType)
  socialType: SocialType | null = null

  url: string | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return this.githubOrganization?.$id ?? 0
  }

  set $id(val) {
    if (!this.githubOrganization) {
      this.githubOrganization = new GithubOrganization()
    }

    this.githubOrganization.$id = val
  }

  get $tag() {
    return String(this.$id)
  }

  async persistGithubOrganizationSocialType() {
    return await Request.post(`/client/github-organization-social-type`, this)
      .name('persistGithubOrganizationSocialType')
      .asNumber()
      .getData()
  }

  async removeGithubOrganizationSocialType() {
    const idOrg = this.githubOrganization?.$id ?? 0
    const idSocial = this.socialType?.$id ?? 0
    return await Request.delete(
      `/client/github-organization-social-type/${idOrg}/${idSocial}`
    )
      .name('removeGithubOrganizationSocialType')
      .asNumber()
      .getData()
  }
}
